import { useMemo } from 'react';
import { useObservations, STALENESS_MS } from '@/stores/observations.store';
import { AGENTS } from '@/tokens/colors';
import type { ReactElement } from 'react';

export default function ObservationsStrip(): ReactElement | null {
  const rawList = useObservations((s) => s.list);
  const list = useMemo(() => {
    const now = Date.now();
    return rawList.filter((o) => now - o.ts <= STALENESS_MS);
  }, [rawList]);
  if (list.length === 0) return null;
  return (
    <div className="border-t border-wayne-hairline pt-2 mt-2 space-y-1" aria-label="Live agent observations">
      {list.map((o) => (
        <div key={o.id} className="flex items-center gap-2 text-xs text-wayne-ink-2">
          <span style={{ color: `var(--agent-${o.agentId})` }}>●</span>
          <span className="font-medium">{AGENTS[o.agentId]?.code ?? o.agentId}</span>
          <span className="truncate">{o.text}</span>
        </div>
      ))}
    </div>
  );
}
